
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/[slug]",
      function () {
        return require("private-next-pages/customers/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customers/[slug]"])
      });
    }
  